export default __webpack_public_path__ + "static/media/Hydralips.da4c0da9.JPG";